export const NOTIFICATIONS_QUERY_KEY = 'notifications';
